import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/employee-list/page";
import type { EmployeeSort } from "@/lib/api/web-api-client";

export interface EmployeeListSearch {
  readonly sort?: EmployeeSort;
}

// The employee-list "Sort by" control persists its choice as `?sort=` (PMO-19
// #476/#523) so a reload or shared link keeps the chosen ordering. Any other
// value is dropped rather than forwarded to the API untyped.
export const Route = createFileRoute(
  "/clients/$clientId/dashboard/employee-list",
)({
  validateSearch: (search: Record<string, unknown>): EmployeeListSearch =>
    search.sort === "name_asc" ||
    search.sort === "name_desc" ||
    search.sort === "recent"
      ? { sort: search.sort }
      : {},
  component: Page,
});
